import DevelopersShow from "../components/developers/Show";

export default [
  { name: 'Developers', path: '/developers', component: DevelopersShow,  }
]
